import { Inject } from '@odinjs/odin';

import Controller, { OnClick, OnDoubleClick, OnSelectItem, OnUnselectItem } from '@philips-emr/tws-core/lib/client';
import { SubmittableFragmentContext } from '@philips-emr/tws-core/lib/component/context';
import { SelectItemEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { Value } from '@philips-emr/tws-core/lib/types';

import BaseController from '../BaseController';

type DataValue = Record<string, Value>;
@Controller({ fragment: 'provider-locator' })
export default class ProviderLocatorController extends BaseController {
  
  @Inject('SubmittableFragmentContext')
  private submittableFragmentContext: SubmittableFragmentContext;

  private selectedProvider: Record<string, Value> = {};

  @OnSelectItem({ target: 'deck-providers' })
  onSelectItemBeneficiarios(event: SelectItemEvent<DataValue>): void {
    this.selectedProvider = event.item;
  }

  @OnUnselectItem({ target: 'deck-beneficiarios' })
  onUnselectItemBeneficiarios(): void {
    this.selectedProvider = {};
  }

  @OnClick({ target: 'button-confirm' })
  onClickButtonConfirmar(): void {
    this.submittableFragmentContext.submit(new SubmitEvent({ record: this.selectedProvider }));
  }

  @OnDoubleClick({ target: 'hpms-custom-card-providers' })
  onClickDeck(): void {
    this.submittableFragmentContext.submit(new SubmitEvent({ record: this.selectedProvider }));
  }

}
